import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Map, List } from 'immutable';

import {
  selectTags,
  selectStatuses,
  savePropertyStatus,
  uploadPropertyDocument,
  deletePropertyDocument,
  loadPropertyDocuments,
  downloadPropertyDocument,
  selectDocuments,
} from 'data/property';
import { saveTag, deleteTag } from 'data/user';
import withProperty from 'app/components/withProperty';

import Button2 from 'components/base/Button';
import Button, { SolidButton } from 'components/Button';
import { BlueLink } from 'components/Link';
import Dropdown, { dropdownable } from 'components/base/Dropdown';
import Checkbox from 'components/base/Checkbox';
import SVG from 'components/base/SVG';
import TeamMemberList from 'app/components/TeamMemberList';
import Confirm from 'app/components/Confirm';
import css from './style.scss';
import { validate, verify, verifyRequired } from 'utils/validation';
import Select from '../../../../components/Select';
import MultiSelect from '../../../../components/MultiSelect';
import MangePropertyTagModal from '../../../components/MangePropertyTagModal';
import CommonNotes from '../../../Campaigns/Dialer/ManageNotes';
import AssignTeamMemberModal from '../../../components/AssignTeamMember';
import { selectUsers } from '../../../../data/user';
import SimpleModal from '../../../../components/base/SimpleModal';

import { Prompt } from 'react-router-dom';
import NotesNotSaved from 'app/AccountNew/modals/NotesNotSaved';
import ConfirmationModal from 'app/AccountNew/modals/ConfirmationModal';

const defaultState = {
  id: null,
  tagEditing: false,
  userEditing: false,
  editTag: null,
  name: '',
  note: '',
  message: '',
  statusId: null,
  assignedTags: [],
  assignedUsers: [],
  initialNote: '',
  initialStatusId: null,
  initialAssignedTags: [],
  initialAssignedUsers: [],
  showNotesModal: false,
  showRemoveModal: false,
  fileToRemove: null,
  nextLocation: null,
  showRemoveUserModal: false,
  userToRemove: null,
};

export class PropertyTags extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleTagChange = this.handleTagChange.bind(this);
    this.handleEditTagClick = this.handleEditTagClick.bind(this);
    this.handleEditUserClick = this.handleEditUserClick.bind(this);
    this.handleSaveTagClick = this.handleSaveTagClick.bind(this);
    this.handleDeleteTagClick = this.handleDeleteTagClick.bind(this);
    this.handleTeamMemberClick = this.handleTeamMemberClick.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleApplyClick = this.handleApplyClick.bind(this);

    this.ref = {};
    this.state = defaultState;
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
    this.loadDocumentsIfNeeded();
    
    const { registerCloseDropdown, closeDropdown } = this.props;
     if (typeof registerCloseDropdown === 'function' && typeof closeDropdown === 'function') {
       registerCloseDropdown(closeDropdown);
     }
   }
   componentWillUnmount() {
     const { registerCloseDropdown } = this.props;
     if (typeof registerCloseDropdown === 'function') {
       registerCloseDropdown(null);
     }
  }

  componentWillReceiveProps(props) {
    const { isOpen, property } = props;
    const id = property.get('id');

    if ((isOpen && !this.props.isOpen) || id !== this.state.id) {
      const status = property.get('status') || Map();
      const { note = '', statusId, assignedTags = [], assignedUsers = [] } = status.toJS();
      this.setState({
        id,
        note,
        statusId,
        assignedTags,
        assignedUsers,
        initialNote: note,
        initialStatusId: statusId,
        initialAssignedTags: assignedTags,
        initialAssignedUsers: assignedUsers,
      });
      this.loadDocumentsIfNeeded(props);
    }
  }

  loadDocumentsIfNeeded(props = this.props) {
    const { savedPropertyId, currentSavedPropertyIdForGroup, isPropertyGroup, loadPropertyDocuments } = props;
    const currentSavedPropertyId = isPropertyGroup ? currentSavedPropertyIdForGroup : savedPropertyId;
    if (currentSavedPropertyId) loadPropertyDocuments(currentSavedPropertyId);
  }

  handleApplyClick() {
    const { note, statusId, assignedTags, assignedUsers, id } = this.state;
    const { savePropertyStatus, closeDropdown, checkSavedProperty } = this.props;
    
    const plainText = note.replace(/<[^>]*>/g, '').trim();
    checkSavedProperty(() => {
      validate(() => {
        verify(null, plainText.length <= 4000, 'Note length cannot exceed 4000 characters.');
        savePropertyStatus(id, { note, statusId, assignedTags, assignedUsers }, closeDropdown);
      });
    });
  }

  handleNoteChange = (html) => {
    this.setState({ note: html || '' });
  };

  getAttachments = (documents = this.props.documents) => (documents || List())
    .filter(d => d.get('editable'))
    .sortBy(d => new Date(d.get('createDate') || 0).getTime())
    .map(d => ({
      id: d.get('id'),
      name: `${d.get('name')}${d.get('fileExtension') ? `.${d.get('fileExtension')}` : ''}`,
    }))
    .toJS();

  handleFileUpload = ({ value: { file } = {} } = {}) => {
    if (!file) return;
    const { uploadPropertyDocument, checkSavedProperty } = this.props;
    checkSavedProperty((savedPropertyId) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', file.name.replace(/\.[^/.]+$/, ''));
      formData.append('description', '');
      uploadPropertyDocument(savedPropertyId, formData);
    });
  };

  handleRemoveAttachment = (index) => {
    const attachments = this.getAttachments();
    const file = attachments[index];
    if (!file || !file.id) return;

    this.setState({
      showRemoveModal: true,
      fileToRemove: file,
    });
  };

  handleConfirmRemove = () => {
    const { deletePropertyDocument } = this.props;
    const { fileToRemove } = this.state;

    if (fileToRemove?.id) {
      deletePropertyDocument(fileToRemove.id);
    }

    this.setState({
      showRemoveModal: false,
      fileToRemove: null,
    });
  };

  handleCancelRemove = () => {
    this.setState({
      showRemoveModal: false,
      fileToRemove: null,
    });
  };

  handleDownloadAttachment = (file) => {
    if (file && file.id) this.props.downloadPropertyDocument(file.id);
  };

  sameIds = (a = [], b = []) => {
    if (a.length !== b.length) return false;
    const sa = [...a].sort((x, y) => x - y);
    const sb = [...b].sort((x, y) => x - y);
    return sa.every((v, i) => v === sb[i]);
  };

  handleChange(ev) {
    const { name, value } = ev.target || ev;
    this.setState({ [name]: value });
  }

  handleStatusChange = (item) => {
    // components/Select's onSelect fires { name, value } (so it can also
    // wire straight into a generic handleChange(ev) handler elsewhere) —
    // not the raw status item, so there's never an `item.id` to read here.
    // That always set statusId to undefined, silently sending an unset
    // status on save.
    if (!item) {
      this.setState({ statusId: null });
      return;
    }

    this.setState({ statusId: item.value || null });
  };

  handleTagChange(ev) {
    const { tagEditing, assignedTags } = this.state;
    const { tags } = this.props;
    const { value, checked } = ev.target || ev;
    const id = Number(value);

    if (!tagEditing) this.setState({ assignedTags: tags.map(t => t.id).filter(tid => ((tid === id && checked) || (tid !== id && assignedTags.includes(tid)))) });
  }

  handleMultiSelectChange = (selectedItems) => {
    const assignedTags = selectedItems.map(item => item.id);
    this.setState({ assignedTags });
  };

  handleTagClick(tag) {
    const { editTag, tagEditing } = this.state;
    const { id } = tag;

    if (tagEditing) {
      const newTag = editTag && editTag.id === id ? null : tag;
      this.setState({ editTag: newTag, name: newTag ? newTag.name : '' });
    }
  }

  handleEditTagClick() {
    this.setState({ tagEditing: !this.state.tagEditing, editTag: null, name: '' }, () => { if (this.state.tagEditing) this.ref.name.focus(); });
  }

  handleEditUserClick() {
    this.setState({ userEditing: !this.state.userEditing, message: '' });
  }

  handleTeamMemberClick({ id, name }) {
    const { confirm } = this.props;
    const { userEditing, assignedUsers } = this.state;

    if (userEditing) this.setState({ assignedUsers: assignedUsers.concat([id]), message: `Team Member ${name} assigned!` });
    else {
      confirm({
        question: `Unassign Team Member ${name}?`,
        okLabel: 'Unassign',
        onOk: () => this.setState({ assignedUsers: assignedUsers.filter(uid => uid !== id) }),
      });
    }
  }

  handleSaveTagClick() {
    const { name, editTag, assignedTags } = this.state;
    const { id } = editTag || {};

    validate(() => {
      const n = name.trim();

      if (editTag && editTag.name === n) this.handleEditTagClick();
      else {
        verifyRequired(this.ref.name, n, 'Name is required.');
        verify(this.ref.name, n.length <= 22, 'Name length cannot exceed 22 characters.');

        this.props.saveTag({ id, name: n, type: 'P' }, ({ response }) => {
          if (!id) this.setState({ assignedTags: assignedTags.concat([response.find(t => t.modified).id]) });
          this.handleEditTagClick();
        });
      }
    });
  }

  handleDeleteTagClick() {
    const { confirm, deleteTag } = this.props;
    const { editTag } = this.state;

    confirm({
      caption: `Delete tag "${editTag.name}"?`,
      question: 'The tag will be removed from all properties it\'s currently assigned to.',
      okLabel: 'Delete',
      onOk: () => deleteTag(editTag.id, this.handleEditTagClick),
    });
  }

  handleRef(ref, name) {
    if (ref) this.ref[name] = ref;
  }

  parseLog(log) {
    const match = log.match(/^(.*?)\s*\((\d{2}\/\d{2}\/\d{4})\s-\s(.+)\)$/);

    if (!match) {
      return {
        event: log,
        date: '',
        user: '',
      };
    }

    return {
      event: match[1],
      date: match[2],
      user: match[3],
    };
  }

  openAssignTeamMemberModal = () => {
    const { AssignTeamMemberModalOpen, users, loading } = this.props;
    const { assignedUsers } = this.state;

    AssignTeamMemberModalOpen({
      teamMembers: users,     // full list
      assignedUsers,
      loading,
      onSave: (updatedUsers) => {
        this.setState({ assignedUsers: updatedUsers });
      },
    });
  };

  openMangePropertyTagModal = () => {
    const { MangePropertyTagModalOpen } = this.props;
    MangePropertyTagModalOpen();
  };

  handleCancelNavigation = () => {
    this.setState({
      showNotesModal: false,
      nextLocation: null,
    });
  };

  handleConfirmNavigation = () => {
    this.handleApplyClick();
    this.setState({
      showNotesModal: false,
      nextLocation: null,
    });
  };

  handleRemoveAssignedUser = (user) => {
    this.setState({
      showRemoveUserModal: true,
      userToRemove: user,
    });
  };
  cancelRemoveUser = () => {
    this.setState({
      showRemoveUserModal: false,
      userToRemove: null,
    });
  };

  confirmRemoveUser = () => {
    const { savePropertyStatus, closeDropdown } = this.props;
    const {
      userToRemove,
      assignedUsers,
      note,
      statusId,
      assignedTags,
      id,
    } = this.state;

    if (!userToRemove) return;

    const updatedUsers = assignedUsers.filter(
      (uid) => uid !== userToRemove.id
    );

    this.setState(
      {
        assignedUsers: updatedUsers,
        showRemoveUserModal: false,
        userToRemove: null,
      },
      () => {
        savePropertyStatus(
          id,
          {
            note,
            statusId,
            assignedTags,
            assignedUsers: updatedUsers,
          },
          closeDropdown
        );
      }
    );
  };

  render() {
    const { closeDropdown, isOpen, onRef, onClick, statuses, tags, loading, property, documents } = this.props;
    const {
      statusId,
      note,
      tagEditing,
      userEditing,
      editTag,
      assignedTags,
      name,
      assignedUsers,
      initialNote,
      initialStatusId,
      initialAssignedTags,
      initialAssignedUsers,
    } = this.state;

    const statusOptions = [{ value: '', label: '--Select Status--' }].concat(statuses.map(s => ({ value: s.id, label: s.name })));
    const logs = property.getIn(['status', 'logs'], List());
    const moreFilesLink = {
      pathname: window.location.pathname,
      hash: "#documents-reports",
    };
    const lastNoteLog = logs
      .map(log => this.parseLog(log))
      .find(({ event }) => /^Note (Added|Changed|Removed)$/i.test(event));

    const lastUpdated = lastNoteLog ? lastNoteLog.date : null;
    const { savedPropertyId } = this.props;
    const attachments = savedPropertyId ? this.getAttachments(documents) : [];
    const notesDirty = (
      note !== initialNote
      || statusId !== initialStatusId
      || !this.sameIds(assignedTags, initialAssignedTags)
      || !this.sameIds(assignedUsers, initialAssignedUsers)
    );

    return (
      <>
        <div onClick={onClick} className={css.tags} name="dropdown-btn">
          <SolidButton className={css.dropdownButton}>
            <SVG icon="iconTag" className={css.iconTag} />
            Status / Tags
          </SolidButton>
          {!isOpen ? null : (
            <div className={css.dropdown} ref={onRef}>
              <div className={css.header}>
                <div className={css.caption}>{this.props.address}</div>
                {/* <Button2 kind="link-default" className={css.btnClose} onClick={closeDropdown}>
                <SVG icon="iconClose" className={css.iconClose} />
                </Button2> */}
              </div>
              <div className={css.propertyFields}>
                <div className={css.field}>
                  <div className={css.label}>Property Status</div>
                  <Select
                    placeholder="Property Status"
                    lists={statuses}
                    selectedValue={statusId}
                    onSelect={this.handleStatusChange}
                  />
                </div>

                <div className={css.field}>
                  <div className={css.labelRow}>
                    <span className={css.label}>Property Tags</span>
                    <span className={css.edit} onClick={this.openMangePropertyTagModal}>Edit</span>
                  </div>
                  <MultiSelect
                    placeholder="Property Tags"
                    lists={tags}
                    selectedValues={assignedTags}
                    onSelect={(ids) => this.setState({ assignedTags: ids.filter(id => tags?.map(tag => tag.id).includes(id)) })}
                  />
                </div>
              </div>
              <div className={css.section}>
                <CommonNotes
                  key={property.get('id')}
                  className={css.notesInTags}
                  value={note}
                  attachmentsDisabled={notesDirty}
                  onChange={this.handleNoteChange}
                  attachments={attachments}
                  onUpload={this.handleFileUpload}
                  onRemoveAttachment={this.handleRemoveAttachment}
                  onDownloadAttachment={this.handleDownloadAttachment}
                  onSave={this.handleApplyClick}
                  notesDirty={notesDirty}
                  lastUpdated={lastUpdated}
                  moreFilesLink={moreFilesLink}
                  onMoreFilesClick={() => {
                    closeDropdown();
                    this.props.onOpenDocumentsTab?.();
                  }}
                />
              </div>

              <div className={css.assignteamMemberwrapper}>
                <div className={css.teamheader}>
                  <div className={css.label}> Assigned Team Members</div>
                  <div className={css.addTeamMemberButton} onClick={this.openAssignTeamMemberModal}><SVG className={css.addIcon} icon={"addIcon"} /> Assign Team Member</div>
                </div>
                {assignedUsers?.length === 0 ?
                  <div className={css.noTeamMembers}>No team member assigned</div>
                  : <TeamMemberList
                    iconSize={42}
                    editButtonText={userEditing ? 'Add' : 'Remove'}
                    onEditClick={this.handleTeamMemberClick}
                    {...({ [userEditing ? 'excludeIds' : 'includeIds']: assignedUsers })}
                    placeholder={`${userEditing ? 'All' : 'No'} Team Members Assigned`}
                    onDeleteClick={this.handleRemoveAssignedUser}
                    loading={loading}
                  />
                }
              </div>

              <div className={css.log}>
                <div className={css.label}>Status Log</div>
                {!logs.size ?
                  <div className={css.logs}>No status available</div>
                  : (

                    <div className={css.logs}>
                      {/* {logs.map(log => <div key={log}>{log}</div>)} */}
                      <div className={css.statusLog}>
                        <div className={css.statusLogheader}>
                          <div>Date</div>
                          <div>Event</div>
                          <div>User</div>
                        </div>

                        <div className={css.statusLogBody}>
                          {logs.map((log, index) => {
                            const { date, event, user } = this.parseLog(log);

                            return (
                              <div className={css.statusLogRow} key={index}>
                                <div className={css.date}>{date}</div>
                                <div className={css.event}>{event}</div>
                                <div className={css.user}>{user}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
              </div>

              <div className={css.buttons}>
                <Button className={css.cancelBtn} loading={loading} onClick={closeDropdown}>
                  Cancel
                </Button>
                <SolidButton className={css.saveBtn} loading={loading} onClick={this.handleApplyClick}>
                  Save
                </SolidButton>
              </div>
              <NotesNotSaved
                isOpen={this.state.showNotesModal}
                onClose={this.handleCancelNavigation}
                onConfirm={this.handleConfirmNavigation}
              />

              <ConfirmationModal
                isOpen={this.state.showRemoveModal}
                onClose={this.handleCancelRemove}
                title="Remove Document?"
                message={<>Are you sure you want to remove this document?<br />It will also be removed from the Documents &amp; Reports section.</>}
                confirmLabel="Remove"
                cancelLabel="Cancel"
                onConfirm={this.handleConfirmRemove}
                isDanger
              />
            </div>
          )}
        </div>
        {
          this.state.showRemoveUserModal && (
            <SimpleModal
              title="Remove Assigned Team Member?"
              description="This team member will be unassigned from this property."
              modalClassName={css.deleteConfirmModal}
              onCancel={this.cancelRemoveUser}
              customFooter={
                <div className={css.customFooter}
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}>
                  <button
                    className={css.cancelSecondary}
                    onClick={this.cancelRemoveUser}
                  >
                    Cancel
                  </button>

                  <button
                    className={`${css.dangerBtn}`}
                    onClick={this.confirmRemoveUser}
                  >
                    Remove
                  </button>
                </div>
              }
            />
          )
        }
      </>
    );
  }
}

export default dropdownable(withProperty(PropertyTags, state => ({
  tags: selectTags(state).toJS(),
  statuses: selectStatuses(state).toJS(),
  documents: selectDocuments(state),
  users: selectUsers(state).toJS(),
}), {
  savePropertyStatus,
  saveTag,
  deleteTag,
  uploadPropertyDocument,
  deletePropertyDocument,
  loadPropertyDocuments,
  downloadPropertyDocument,
  confirm: Confirm.open,
  MangePropertyTagModalOpen: MangePropertyTagModal?.open,
  AssignTeamMemberModalOpen: AssignTeamMemberModal?.open
}));
